import { useState, useEffect } from 'react';

/**
 * This custom hook manages the sticky position of a navigation banner container.
 * It observes the container's resize events and updates the sticky position accordingly.
 *
 * @returns An object containing the following property:
 *   - stickyPosition: The current sticky position of the navigation banner container.
 */
const useStickyPosition = () => {
    const defaultValue: number = 50;
    const [stickyPosition, setStickyPosition] = useState<number>(defaultValue);

    useEffect(() => {
        let resizeObserver: ResizeObserver | undefined;
        const navBannerContainer = document.getElementById('handleScroll');
        if (navBannerContainer) {
            try {
                resizeObserver = new ResizeObserver(navBannerResizeObserverCallback);
                resizeObserver.observe(navBannerContainer);
            } catch (error) {
                setStickyPosition(defaultValue);
            }
        } else {
            setStickyPosition(defaultValue);
        }
        return () => resizeObserver?.disconnect();
    }, []);

    const navBannerResizeObserverCallback: ResizeObserverCallback = (entries: ResizeObserverEntry[]) => {
        entries.forEach((entry: ResizeObserverEntry) => {
            const newHeight: number = (entry.target as HTMLDivElement).offsetHeight;
            setStickyPosition(newHeight)
        });
    }

    return { stickyPosition };
}

export default useStickyPosition;
